import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import MdmSelect from '~/components/atoms/MdmSelect.vue';
import MdmRadio from '~/components/atoms/MdmRadio.vue';
import TextArea from '~/components/atoms/TextArea.vue';
import MdmIcon from '~/components/atoms/Global/MdmIcon';
import UploadPhoto from '~/components/organisms/Webform/UploadPhoto.vue';
var ELIGIBILITY_NULL = 0;
var IS_ELIGIBLE = 1;
var IS_NOT_ELIGIBLE = 2;
var IS_NOT_ELIGIBLE_MAG = 3;
export default {
  name: 'FormReasonsReturnRefuse',
  components: {
    MdmSelect,
    MdmRadio,
    TextArea,
    MdmIcon,
    UploadPhoto
  },
  props: {
    isReturnable: {
      type: Boolean,
      default: true
    },
    channel: {
      type: String,
      required: true
    },
    reasons: {
      type: Object,
      required: true
    },
    isRefusalTemplate: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      form: {
        reason: {
          value: null,
          displayed: true,
          error: null,
          required: null
        },
        subReason: {
          value: null,
          displayed: false,
          error: null,
          required: null
        },
        reserve: {
          value: null,
          displayed: false,
          error: null,
          required: null
        },
        comment: {
          value: '',
          displayed: false,
          error: null,
          required: null
        },
        productPhotos: {
          value: null,
          displayed: false,
          error: null,
          required: null
        }
      },
      eligibility: ELIGIBILITY_NULL,
      showNotEligibleText: false,
      showNotEligibleMagText: false,
      selectedReason: null
    };
  },

  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    subReasonList() {
      if (this.selectedReason && this.selectedReason.subReason) {
        return this.selectedReason.subReason[this.language];
      }

      return [];
    },

    language() {
      return this.locale.language;
    },

    reserveOptions() {
      return [{
        label: this.$t('radio.yes'),
        value: 'yes'
      }, {
        label: this.$t('radio.no'),
        value: 'no'
      }];
    },

    formCommentLabel() {
      return this.$t('comment.text', {
        constraint: this.constraintLabel(this.form.comment.required)
      });
    },

    isMag() {
      return this.channel === 'mag';
    },

    isFormReasonsValid() {
      var reasons = Object.keys(this.form);
      return this.isProductReturnEligible() && reasons.every(field => {
        var {
          error
        } = this.form[field];
        if (error === null) return false;
        return !error;
      });
    }

  }),
  watch: {
    eligibility() {
      this.showErrorMsg();

      if (this.isProductReturnEligible()) {
        /* In case Reserve is not displayed,
         * Display non-togglable elements
         */
        this.form.comment.displayed = true;
        this.form.productPhotos.displayed = true;
      }
    },

    /* If Bl has changed,
     * re calculate form configuration
     * (based on previously selected choices)
     */
    channel() {
      if (this.form.reason.value) {
        this.setFormConfiguration();
      }
    }

  },
  methods: {
    isProductReturnEligible() {
      return this.eligibility === IS_ELIGIBLE;
    },

    showErrorMsg() {
      this.resetMsg();
      var {
        nonEligibleMag
      } = this.selectedReason;

      if (this.isMag && nonEligibleMag) {
        this.showNotEligibleMagText = this.eligibility === IS_NOT_ELIGIBLE_MAG;
      } else {
        this.showNotEligibleText = this.eligibility === IS_NOT_ELIGIBLE;
      }
    },

    constraintLabel(isCommentRequired) {
      return isCommentRequired ? this.$t('comment.required') : this.$t('comment.optional');
    },

    onReasonChange() {
      this.selectedReason = this.reasons.label.find((_ref) => {
        var {
          reason
        } = _ref;
        return reason[this.language] === this.form.reason.value;
      });
      this.validateField('reason');
      this.setFormConfiguration();
    },

    setFormConfiguration() {
      this.subReasonConfiguration();
      this.reserveConfiguration();
      this.commentConfiguration();
      this.picturesConfiguration();
      this.eligibilityConfiguration();
    },

    subReasonConfiguration() {
      this.resetSubReasons();
      var {
        subReason,
        nonEligibleMag
      } = this.selectedReason;
      var displaySubReason;

      if (nonEligibleMag && this.isMag) {
        displaySubReason = false;
      } else {
        displaySubReason = !!subReason;
      }

      this.form.subReason.displayed = displaySubReason;
      this.form.subReason.required = displaySubReason;

      if (!displaySubReason) {
        this.form.subReason.error = false;
      }
    },

    reserveConfiguration() {
      var {
        noReserve
      } = this.selectedReason;
      this.form.reserve.displayed = !noReserve;
      this.form.reserve.required = !noReserve;

      if (noReserve) {
        this.form.reserve.value = null;
        this.form.reserve.error = false;
      }
    },

    commentConfiguration() {
      var {
        optionalComment,
        noReserve
      } = this.selectedReason;
      this.form.comment.required = !optionalComment;

      if (noReserve) {
        this.form.comment.displayed = true;
      }
    },

    picturesConfiguration() {
      var {
        noPictureRequired,
        noReserve
      } = this.selectedReason;
      this.form.productPhotos.required = !noPictureRequired;
      this.form.productPhotos.error = !this.form.productPhotos.value && this.form.productPhotos.required ? null : false;

      if (noReserve) {
        this.form.productPhotos.displayed = true;
      }
    },

    eligibilityConfiguration() {
      this.eligibility = ELIGIBILITY_NULL;
      var {
        noReserve,
        nonEligibleMag,
        checkReturnable
      } = this.selectedReason;
      /* If Bl has changed,
       * calculate eligibility from previously selected reserve
       */

      if (this.form.reserve.value) {
        this.calculateEligibiltyOnReserve();
      }

      if (noReserve) {
        this.eligibility = IS_ELIGIBLE;
      }

      if (noReserve && checkReturnable) {
        this.checkDays();
      }

      if (this.isMag && nonEligibleMag) {
        this.eligibility = IS_NOT_ELIGIBLE_MAG;
      }
    },

    resetMsg() {
      this.showNotEligibleMagText = false;
      this.showNotEligibleText = false;
    },

    calculateEligibiltyOnReserve() {
      var isReserveChecked = this.form.reserve.value === 'yes';

      if (isReserveChecked) {
        this.eligibility = IS_ELIGIBLE;
      } else {
        this.checkDays();
      }
    },

    checkDays() {
      this.eligibility = this.isReturnable ? IS_ELIGIBLE : IS_NOT_ELIGIBLE;
    },

    validateField(key) {
      this.form[key].error = !this.form[key].value && this.form[key].displayed && this.form[key].required;
    },

    resetSubReasons() {
      this.form.subReason.error = null;
      this.form.subReason.value = null;
    },

    onUploadPhotos(photos) {
      this.form.productPhotos.value = null;

      if (photos.length) {
        this.form.productPhotos.value = photos;
      }

      this.validateField('productPhotos');
    },

    sendForm() {
      var form = {
        reason: this.form.reason.value,
        subReason: this.form.subReason.value,
        reserve: this.form.reserve.value,
        comment: this.form.comment.value,
        productPhotos: this.form.productPhotos.value
      };
      this.$emit('update-reasons', form);
    }

  }
};